// FROM: https://github.com/modusign/modusign-client/blob/1f2cc00e317b3cc6ddf42ace319c72036470a423/app/src/components/ParticipantCardButtons/index.tsx
import { Flex } from '@modusign/design-system';
import { SigningMethod } from '@modusign/react-signing/types';

import { SigningMethodTypeButton } from './SigningMethodTypeButton';

function SignerCardButtons({
  selectableMethods,
  blockedByPermissionTypes,
  onSelectMethodClick,
}: {
  selectableMethods: SigningMethod[];
  blockedByPermissionTypes?: SigningMethod[];
  onSelectMethodClick: (method: SigningMethod | null) => void;
}) {
  return (
    <Flex alignItems="center">
      {selectableMethods.map((type) => {
        return (
          <SigningMethodTypeButton
            isSelectBlocked={!!blockedByPermissionTypes?.includes(type)}
            key={type}
            type={type}
            onClick={() => onSelectMethodClick(type)}
          />
        );
      })}
    </Flex>
  );
}

export default SignerCardButtons;
